import VisibilityIcon from '@mui/icons-material/Visibility';
import FolderIcon from '@mui/icons-material/Folder';
import ViewAgendaIcon from '@mui/icons-material/ViewAgenda';
import StickyNote2Icon from '@mui/icons-material/StickyNote2';
import CloudIcon from '@mui/icons-material/Cloud';
import TimelineIcon from '@mui/icons-material/Timeline';

// Same icon-per-shape-kind as the Add-shape toolbar buttons (UmlCanvasToolbarButtons.jsx),
// so a hidden-items row is instantly recognizable against the rest of the UI.
const SHAPE_KIND_ICONS = {
    package: <FolderIcon sx={{ fontSize: 14 }} />,
    class: <ViewAgendaIcon sx={{ fontSize: 14 }} />,
    comment: <StickyNote2Icon sx={{ fontSize: 14 }} />,
    icon: <CloudIcon sx={{ fontSize: 14 }} />,
};

const INDENT_PER_DEPTH = 16;

/**
 * One row in UmlHiddenItemsDlg's tree list — a type-badge icon, the item's
 * label indented by nesting depth (item.depth, see UmlHiddenItemsHelpers.
 * buildShapeRows), and (top-level rows only, item.isTopLevel) a Show icon
 * that un-hides it (umlCanvasEngine.setItemHidden(id, false)).
 *
 * Nested descendant rows (depth > 0) are display-only: they're implicitly
 * hidden as a side effect of their hidden ancestor package (see
 * resolveUserHiddenItems.js cascade) — un-hiding just one nested item on its
 * own isn't supported yet (it would still not render while its parent stays
 * hidden), so no action is offered for those rows, just a muted "nested" tag.
 * @param {{item: {id:string, type:'shape'|'connector', kind:string, label:string, depth:number, isTopLevel:boolean}, onShow: Function}} props
 */
export default function UmlHiddenItemsRow({ item, onShow }) {
    const icon = item.type === 'connector' ? <TimelineIcon sx={{ fontSize: 14 }} /> : SHAPE_KIND_ICONS[item.kind] || <FolderIcon sx={{ fontSize: 14 }} />;

    return (
        <div
            className={`uhid-row ${item.isTopLevel ? '' : 'uhid-row-nested'}`}
            style={{ paddingLeft: 6 + item.depth * INDENT_PER_DEPTH }}
        >
            <span className="uhid-row-icon">{icon}</span>
            <span className="uhid-row-label">{item.label}</span>
            {item.isTopLevel ? (
                <VisibilityIcon
                    className="uhid-row-show"
                    onClick={() => onShow(item.id)}
                    sx={{ fontSize: 16 }}
                    titleAccess="Show"
                />
            ) : (
                <span className="uhid-row-nested-note" title="Hidden because a parent package is hidden">
                    nested
                </span>
            )}
        </div>
    );
}
